var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-page"},[_c('div',{staticClass:"v-page__wrapper",domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.isLoad)?_c('Loader',{class:{
      "v-page__loader": true,
      "v-page__loader--is-loading": true,
    }}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }